'use client';

import React from 'react';
import { RevshareSubscriber } from '../types';
import { CalendarIcon } from '../../../../components/icons';
import { useTranslations } from '../../../../contexts/translation.context';

interface DateCellProps {
  subscriber: RevshareSubscriber;
}

const DateCell: React.FC<DateCellProps> = ({ subscriber }) => {
  const { lang } = useTranslations();

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(lang === 'ru' ? 'ru-RU' : 'en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString(lang === 'ru' ? 'ru-RU' : 'en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // Calculate time ago
  const getTimeAgo = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      const hours = diffHours % 24;
      return lang === 'ru' ? `${diffDays}д. ${hours}ч. назад` : `${diffDays}d ${hours}h ago`;
    }
    if (diffHours > 0) {
      const mins = diffMins % 60;
      return lang === 'ru' ? `${diffHours}ч. ${mins}мин. назад` : `${diffHours}h ${mins}min ago`;
    }
    if (diffMins > 0) {
      const secs = diffSecs % 60;
      return lang === 'ru' ? `${diffMins}мин. ${secs}сек. назад` : `${diffMins}min ${secs}sec ago`;
    }
    if (diffSecs > 0) {
      return lang === 'ru' ? `${diffSecs}сек. назад` : `${diffSecs}sec ago`;
    }
    return lang === 'ru' ? 'только что' : 'just now';
  };

  const timeAgo = getTimeAgo(subscriber.created_at);

  return (
    <div className="flex flex-col">
      <div className="flex items-start gap-1">
        <CalendarIcon className="w-3.5 h-3.5 mt-[1px]" />
        <div className="flex flex-col text-auth-muted text-xs leading-4">
          <span>{timeAgo}</span>
          <span>
            {formatDate(subscriber.created_at)} {formatTime(subscriber.created_at)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DateCell;
